import Cookies from 'js-cookie';

import { createStore } from '../_core/createStore';
import { cookieStore } from './cookieStore';

const useCookieStore = createStore({
  creator: cookieStore({ Cookies }),
  id: 'cookie',
  middlewares: {
    devtools: true,
  },
});

export default useCookieStore;
